import React from 'react'
import classNames from 'classnames'
import T from 'components/FormattedMessage'
import { WithStyles, Theme, withStyles, createStyles } from '@material-ui/core/styles'
import { ButtonBase, Grid, Typography } from '@material-ui/core'
import ExpandLess from '@material-ui/icons/ExpandLess'
import ExpandMore from '@material-ui/icons/ExpandMore'

import inactiveChatIconUrl from '../../assets/chat_inactive.svg'
import activeChatIconUrl from '../../assets/chat_active.svg'

interface Props {
  open?: boolean
  active?: boolean
  numComments?: number
  onClick?: () => void
}

const styles = (theme: Theme) => createStyles({
  root: {
    width: '100%',
    display: 'block',
    height: theme.components.GameChatBar.height,
    textAlign: 'left',
    backgroundColor: theme.palette.common.white,
    boxShadow: '0 7px 7px -7px rgba(0, 0, 0, 0.25)',
  },
  disabled: {
    opacity: 0.5,
  },
  container: {
    height: theme.components.GameChatBar.height,
    paddingLeft: theme.spacing() * 2,
    paddingRight: theme.spacing() * 2,
  },
  icon: {
    marginRight: theme.spacing(),
  },
})

type InjectedProps = Props & WithStyles<typeof styles>

const GameChatBar: React.FC<InjectedProps> = ({
  classes,
  active,
  open,
  numComments,
  onClick,
}) => (
    <ButtonBase classes={{ root: classes.root }} disabled={!active} onClick={onClick}>
      <Grid
        container
        alignItems="center"
        className={classNames(classes.container, { [classes.disabled]: !active })}
      >
        <img
          alt=""
          src={active ? activeChatIconUrl : inactiveChatIconUrl}
          className={classes.icon}
        />
        <Grid item xs>
          <Typography variant="body1" component="span">
            <T id="chat_comments" />
          </Typography>
          {(numComments as number) > 0 && (
            <Typography variant="body2" component="span">
              {' '}
            ({numComments})
            </Typography>
          )}
        </Grid>
        {open ? <ExpandMore /> : <ExpandLess />}
      </Grid>
    </ButtonBase>
  )

export default withStyles(styles)(GameChatBar)
